import Axios from 'axios'
import { getErrorMessage, SPECTRA_URL } from '@/main'

const state = {
  _spectraSearchResult: { file: [], records: [] },
}

const getters = {
  spectraSearchResult: (state) => {
    return state._spectraSearchResult
  },
}

const mutations = {
  spectraSearchResult: (state, payload) => {
    state._spectraSearchResult = payload
  },
  resetSpectraResult: (state) => {
    state._spectraSearchResult = { file: [], records: [] }
  },
}

const actions = {}

export function prepareSpectraMetadata(context) {
  Axios.get(`${SPECTRA_URL}/metadata`)
    .then(() => {
      context.commit('setFeatures', { spectra: { category: 'spectra' } })
    })
    .catch((error) => {
      console.warn('SPECTRA module is not available: %o', getErrorMessage(error))
      context.commit('removeFeature', { spectra: {} })
    })
}

export default {
  state,
  getters,
  mutations,
  actions,
}
